module.exports = __webpack_public_path__ + "public/img/loginBg.10c58022.jpg";